import { useState } from "react";

import contact_mo from "../../../assets/images/Contact-us/contact_mo.webp";
import contact_pc from "../../../assets/images/Contact-us/contact_pc.webp";
import loca from "../../../assets/images/Contact-us/loca.svg";
import { Button } from "flowbite-react";
import smsck from "../../../assets/images/Contact-us/smsck.svg";
import { NotificationManager } from "react-notifications";
import { FiPhone } from "react-icons/fi";
import axios from "axios";

export default function ContactBody() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    service: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const phoneRegex = /^[0-9]{10,11}$/;
    if (!phoneRegex.test(formData.phone)) {
      NotificationManager.error("Số điện thoại không hợp lệ", "Lỗi", 3000);
      return;
    }

    setError("");
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      NotificationManager.success(
        "Thông tin đã được gửi thành công!",
        "Thành công",
        3000
      );

      setFormData({
        name: "",
        phone: "",
        email: "",
        service: "",
        message: "",
      });
    }, 2000);
    const rowData = [
      formData.name,
      formData.phone,
      formData.email,
      formData.service,
      formData.message,

      new Date().toLocaleString(),
    ];
    const response = await axios.post(
      "https://api-bluerise.bluerise.com.vn/contact-us",
      {
        values: rowData,
      }
    );
  };

  return (
    <div className="w-full">
      <div className="w-full mx-auto container px-[20px] py-[20px] grid grid-cols-1 lg:grid-cols-2 gap-5">
        <div className="w-full bg-[#fafafa] px-[30px] py-[16px] rounded-[16px] flex flex-col gap-4">
          <div className="w-full flex flex-col gap-2">
            <p className="text-[28px] md:text-[32px] font-semibold text-[#1F1F1F]">
              Để lại lời nhắn cho chúng tôi
            </p>
            <p className="text-[16px] text-[#1F1F1F] font-normal">
              Hãy cho chúng tôi biết về nhu cầu của bạn! Hãy gửi tin nhắn nhanh
              cho chúng tôi bằng cách sử dụng biểu mẫu bên dưới và nhóm hỗ trợ
              tận tâm của chúng tôi sẽ liên hệ lại với bạn ngay lập tức.
            </p>
          </div>
          <div>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-gray-700 font-medium mb-1">
                  Họ và tên
                </label>
                <div className="flex items-center border border-gray-300 rounded-[16px] p-2">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Nhập họ và tên của bạn"
                    className="flex-1 bg-transparent border-none outline-none placeholder-gray-400"
                  />
                </div>
              </div>

              <div className="w-full flex flex-col md:flex-row items-center gap-2 md:gap-3">
                <div className="mb-4 w-full">
                  <label className="block text-gray-700 font-medium mb-1">
                    Số điện thoại
                  </label>
                  <div className="flex items-center border border-gray-300 rounded-[16px] p-2">
                    <input
                      type="text"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="Số điện thoại của bạn"
                      className="flex-1 bg-transparent border-none outline-none placeholder-gray-400"
                      maxLength="11"
                    />
                  </div>
                  {error && <p className="text-red-500 text-sm">{error}</p>}
                </div>

                <div className="mb-4 w-full ">
                  <label className="block text-gray-700 font-medium mb-1">
                    Địa chỉ Email
                  </label>
                  <div className="flex items-center border border-gray-300 rounded-[16px] p-2">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Email của bạn"
                      className="flex-1 bg-transparent border-none outline-none placeholder-gray-400"
                    />
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-medium mb-1">
                  Gói dịch vụ cần tư vấn
                </label>
                <div className="flex items-center border border-gray-300 rounded-[16px] p-2">
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    className="flex-1 bg-transparent outline-none border-none placeholder-gray-400"
                  >
                    <option value="">Chọn gói dịch vụ cần tư vấn</option>
                    <option value="Basic">Basic</option>
                    <option value="Premium">Premium</option>
                    <option value="Unlimited">Unlimited</option>
                  </select>
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-medium mb-1">
                  Lời nhắn
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="Hãy để lại lời nhắn của bạn"
                  className="w-full border border-gray-300 rounded-[16px] p-2 bg-transparent outline-none placeholder-gray-400"
                  rows="4"
                ></textarea>
              </div>

              <div className="flex items-center justify-center md:justify-center lg:justify-start">
                <Button
                  type="submit"
                  className={`w-full h-[54px] bg-[#053CC8] md:w-full hover:bg-pa lg:w-[300px] flex items-center justify-center rounded-[30px] ${
                    isLoading ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  disabled={isLoading}
                >
                  {isLoading ? "Đang gửi..." : "Gửi lời nhắn"}
                </Button>
              </div>
            </form>
          </div>
        </div>
        <div className="w-full rounded-lg">
          <img
            src={contact_mo}
            alt="con5"
            className="w-full object-cover block md:hidden rounded-lg"
          />
          <img
            src={contact_pc}
            alt="con6"
            className="hidden md:block w-full h-[700px] object-contain md:w-full rounded-xl"
          />
        </div>
      </div>

      <div className="w-full container mx-auto px-[20px] py-[20px] flex flex-col md:flex-row gap-5 md:gap-3">
        <div className="w-full flex flex-col gap-2 bg-[#fafafa] px-[24px] py-[16px] rounded-[16px] hover:border hover:border-blue-500">
          <img src={loca} alt="lo" className="w-[28px] h-[28px]" />
          <p className="text-[18px] text-[#606060] font-medium">Địa chỉ</p>
          <p className="text-[#1F1F1F] text-[16px] font-normal">
            BT16B6-32, Làng Việt Kiều Châu Âu, Phường Mộ Lao, Quận Hà Đông,
            Thành phố Hà Nội.
          </p>
        </div>
        <div className="w-full flex flex-col gap-2 bg-[#fafafa] px-[24px] py-[16px] rounded-[16px] hover:border hover:border-blue-500">
          <img src={smsck} alt="sm" className="w-[28px] h-[28px]" />
          <p className="text-[18px] text-[#606060] font-medium">Email</p>
          <p className="text-[#1F1F1F] text-[16px] font-normal">
            Support@bluerise.com.vn
          </p>
        </div>
        <div className="w-full flex flex-col gap-2 bg-[#fafafa] px-[24px] py-[16px] rounded-[16px] hover:border hover:border-blue-500">
          <FiPhone className="w-[26px] h-[26px] text-blue-500" />
          <p className="text-[18px] text-[#606060] font-medium">Hotline</p>
          <p className="text-[#1F1F1F] text-[16px] font-normal">0981.317.225</p>
        </div>
      </div>
    </div>
  );
}
